import { render } from "./SeWageEmployment.vue?vue&type=template&id=38508ae9&scoped=true"
import script from "./SeWageEmployment.vue?vue&type=script&lang=js"
export * from "./SeWageEmployment.vue?vue&type=script&lang=js"

import "./SeWageEmployment.vue?vue&type=style&index=0&id=38508ae9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38508ae9"]])

export default __exports__